// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loading_Container__20YN0","InnerCont":"Loading_InnerCont__3SIfr","Logo":"Loading_Logo__3-_3y","Backdrop":"Loading_Backdrop__2Cbcu","scale":"Loading_scale__1YMQR"};